import React from "react";
import {
    Modal,
    Row,
    Col,
    Input,
    Radio,
    message,
    DatePicker,
    Select
} from "antd";
import TableC from '../../basicElement/TableC';
import SearchRetrieve from '../../common/SearchRetrieve.new.js';
import $ from "../../../common/AjaxRequest";
import API_URL from "../../../common/url";
import moment from "moment";

const { TextArea } = Input;
const { Option } = Select;
const RadioGroup = Radio.Group;
const dateFormat = 'YYYY-MM-DD';
const typeInConfig = {
    add: {
        title: '新建交接任务',
        message: '新建成功',
        url: API_URL.execute.addHandover,
    },
    edit: {
        title: '修改交接任务',
        message: '修改成功',
        url: API_URL.execute.modifyHandover,
    },
};
const genConfig = (type) => {
    return {
        ...typeInConfig[type],
        [type]: true
    };
};
let config = {};

class Update extends React.Component {
    constructor(props) {
        super(props);

        this.siteId = undefined;
        this.isConcrete = false;

        this.city = undefined;
        this.courtyardArea = undefined;
        this.departmentLocalName = undefined;
        this.columns = [];
        this.investigationSiteList = [];
        this.proCompTime = moment().add(15, "days").format(dateFormat);
        
        this.state = {
            visible: false,
            loading: false,
            saveParams: {},
            fteData: [],
            handvoerConList:[]
        };
    }
    componentDidMount(){
        this.queryHandvoerConList()
    }
    
    queryHandvoerConList = () => {
        const options = {
            method: 'POST',
            url: API_URL.execute.queryHandvoerConList,
            data: {},
            dataType: 'json',
            doneResult: res => {
                const { datas = [] } = res;
                this.setState({ handvoerConList:datas });
            },
        };
        $.sendRequest(options);
    }

    loadData = () => {
        this.setState({ loading: true });
        const options = {
            url: API_URL.execute.queryBySiteId,
            data: { investigationSiteId: this.siteId },
            dataType: "json",
            doneResult: (res) => {
                const { site: { investigationSiteId, investigationSiteName, investigationSiteCode, city, courtyardArea, departmentLocalName } = {} } = res.data || {};
                const { saveParams } = this.state;

                this.city = city;
                this.courtyardArea = courtyardArea;
                this.departmentLocalName = departmentLocalName;
                saveParams.invSiteId = investigationSiteId;
                saveParams.invSiteName = investigationSiteName;
                saveParams.invSiteCode = investigationSiteCode;

                this.setState({
                    saveParams,
                    loading: false,
                });
            },
        };
        $.sendRequest(options);
    }

    queryFte = () => {
        const { saveParams } = this.state;
        const { handoverUserId, invSiteId, proCompTime } = saveParams;

        this.showFteTable = handoverUserId && proCompTime;
        if (this.showFteTable) {
            const options = {
                url: API_URL.execute.handlerEstimateHandOverFte,
                data: {
                    handoverUserId,
                    invSiteId,
                    proCompTime,
                },
                dataType: "json",
                doneResult: (res) => {
                    const data = res.datas || [];

                    let list = [];
                    if (data.length) {
                        const item = { name: 'FTE' };
                        const columns = [{
                            title: '时间',
                            dataIndex: 'name',
                            key: 'name',
                            fixed: 'left',
                            width: 60
                        }];
                        // 将列表转换成数据项
                        for (let i = 0, len = data.length; i < len; i++) {
                            const { year, month, planFte } = data[i];
                            const date = `${year}.${month}`;
                            
                            item[date] = planFte;
                            columns.push({
                                title: date,
                                dataIndex: date,
                                key: date,
                                width: 60
                            });
                        }

                        this.columns = columns;
                        list.push(item);
                    }

                    this.setState({ fteData: list });
                },
            };
            $.sendRequest(options);
        } else {
            this.setState({ fteData: [] });
        }
    }

    show = (record, type) => {
        const { siteId, invState } = sessionStorage;
        this.siteId = siteId;
        this.isConcrete = invState == 2;

        this.investigationSiteList = [];

        const saveParams = {};
        
        config = genConfig(type);
        if (config.add) {
            this.city = undefined;
            this.courtyardArea = undefined;
            this.departmentName = undefined;
            saveParams.proCompTime = this.proCompTime;
        } else {
            const {
                requirementId, handoverUser, handoverUserId, handoverUserCode, requirementComment, estimateCompletedTime,
                proCompTime, city, investigationSiteId, investigationSiteName, investigationSiteCode,
                handoverReasonId,handoverReasonRemark,courtyardArea,departmentName
            } = record;
            
            this.city = city;
            this.courtyardArea = courtyardArea;
            this.departmentLocalName = departmentName;
            saveParams.requirementId = requirementId;
            saveParams.handoverUserId = handoverUserId;
            saveParams.handoverUserName = `${handoverUser}[${handoverUserCode}]`;
            saveParams.invSiteId = investigationSiteId;
            saveParams.handoverReasonId = handoverReasonId;saveParams.handoverReasonRemark = handoverReasonRemark;
            saveParams.invSiteName = investigationSiteName;
            saveParams.invSiteCode = investigationSiteCode;
            saveParams.comment = requirementComment;
            saveParams.estimateCompletedTime = estimateCompletedTime ? estimateCompletedTime.slice(0, 10) : undefined;
            saveParams.proCompTime = proCompTime ? proCompTime.slice(0, 10) : undefined;
        }

        this.setState({
            visible: true,
            saveParams,
        }, () => {
            if (config.add) {
                if (this.isConcrete) {
                    this.loadData();
                }
            } else {
                this.queryFte();
            }
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    handleChange = (value, key) => {
        const { saveParams } = this.state;
        
        switch (key) {
            case 'handoverUser': {
                console.log(value);
                const { value: id, text: name, investigationSiteList } = value;
                const [{ city, investigationSiteId, courtyardArea, departmentName  } = {}] = investigationSiteList || [];
                this.city = city;
                this.courtyardArea = courtyardArea;
                this.departmentName = departmentName;
                this.investigationSiteList = investigationSiteList;

                saveParams[`${key}Id`] = id;
                saveParams[`${key}Name`] = name;

                if (!this.isConcrete) {
                    saveParams.invSiteId = investigationSiteId;
                }

                this.setState({ saveParams }, () => {
                    this.queryFte();
                });
                break;
            }
            case "invSiteId": {
                const { value: id, city } = value;
                this.city = city;
                saveParams[key] = id;
                this.setState({ saveParams }, () => {
                    this.queryFte();
                });
                break;
            }
            case "proCompTime": {
                saveParams[key] = value;
                this.setState({ saveParams }, () => {
                    this.queryFte();
                });
            }
            default:
                saveParams[key] = value;
                this.setState({ saveParams });
                break;
        }
    }

    getFteTable = () => {
        const { fteData } = this.state;
        if ((fteData || []).length) {
            return (
                <TableC
                    columns={this.columns}
                    data={fteData}
                    className="fte"
                    reRenderTime={0}
                />
            );
        } else {
            return '没有可交接的FTE';
        }
    }

    handleSubmit = () => {
        const { saveParams, fteData } = this.state;
        const { handoverUserId, invSiteId, estimateCompletedTime, proCompTime, handoverReasonId, handoverReasonRemark } = saveParams;

        if (!handoverUserId) {
            return message.warning("请选择交接人");
        }
        if (!invSiteId) {
            return message.warning("请选择中心");
        }
        if (handoverReasonId == 8 && !handoverReasonRemark){
            return message.warning("请输入其他原因备注");
        }
        if (!estimateCompletedTime) {
            return message.warning("请选择预计上岗时间");
        }
        if (!proCompTime) {
            return message.warning("请选择预计交接完成时间");
        }
        if (!fteData.length) {
            return message.warning("当前交接人没有可交接的FTE，请在人员需求列表中，调整其FTE后再做交接");
        }

        this.setState({ loading: true });
        const options = {
            url: config.url,
            data: saveParams,
            dataType: "json",
            doneResult: () => {
                message.success(config.message);
                this.setState({ loading: false }, () => {
                    this.hide();
                    this.props.reload();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    render() {
        const { visible, loading, saveParams ,handvoerConList=[] } = this.state;
        const siteOption = (this.investigationSiteList || []).map(i =>
            <Radio
                className="radioStyle"
                city={i.city}
                value={i.investigationSiteId}
                key={i.investigationSiteId}
            >
                {i.investigationSiteName}({i.investigationSiteCode})
            </Radio>
        );
        const handvoerConOptopn = handvoerConList.map( el => {
            return <Option key={el.handoverConfigureId} value={el.handoverConfigureId}>{el.configureValue}</Option>
        })
        return (
            <Modal
                title={config.title}
                visible={visible}
                onOk={this.handleSubmit}
                onCancel={this.hide}
                width="600px"
                confirmLoading={loading}
                maskClosable={false}
            >
                <Row>
                    <Col span={6} style={{ textAlign: 'right' }}>交接人：</Col>
                    <Col span={17} offset={1}>
                        <SearchRetrieve
                            keyword='keyword'
                            style={{ width: 200 }}
                            disabled={config.edit}
                            placeholder="输入姓名/工号检索"
                            value={saveParams.handoverUserName}
                            params={{ limit: 20 }}
                            url={API_URL.execute.queryCRCListByKeywordForHandover}
                            config={{ id: 'userId', name: 'userName', code: 'employeeCode', type: 'handover', show: 'user' }}
                            onChange={value => this.handleChange(value, 'handoverUser')}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col span={6} style={{ textAlign: 'right' }}>交接中心(中心编号)：</Col>
                    <Col span={17} offset={1}>
                        {
                            (this.isConcrete || config.edit) ? 
                                `${saveParams.invSiteName}(${saveParams.invSiteCode})`
                            :
                                <RadioGroup
                                    onChange={e => this.handleChange(e.target, 'invSiteId')}
                                    value={saveParams.invSiteId}
                                >
                                    {siteOption}
                                </RadioGroup>
                        }
                    </Col>
                </Row>
                <Row>
                    <Col span={6} style={{ textAlign: 'right' }}>院区：</Col>
                    <Col span={17} offset={1}>{this.courtyardArea}</Col>
                </Row>
                <Row>
                    <Col span={6} style={{ textAlign: 'right' }}>科室：</Col>
                    <Col span={17} offset={1}>{this.departmentName}</Col>
                </Row>
                <Row>
                    <Col span={6} style={{ textAlign: 'right' }}>城市：</Col>
                    <Col span={17} offset={1}>{this.city}</Col>
                </Row>
                <Row style={{ marginBottom: 10 }}>
                    <Col span={6} style={{ textAlign: 'right' }}>接收人要求：</Col>
                    <Col span={17} offset={1}>
                        <TextArea
                            placeholder="请填写"
                            value={saveParams.comment}
                            autosize={{ minRows: 3, maxRows: 6 }}
                            onChange={e => this.handleChange(e.target.value, 'comment')}
                        />
                    </Col>
                </Row>
                <Row >
                    <Col span={6} style={{ textAlign: 'right' }}>交接原因：</Col>
                    <Col span={17} offset={1}>
                        <Select
                            style={{ width: 200 }}
                            placeholder="请选择交接原因"
                            value={saveParams.handoverReasonId}
                            onChange={value => this.handleChange(value, 'handoverReasonId')}
                        >
                            {handvoerConOptopn}
                        </Select>
                    </Col>
                </Row>
                {
                    saveParams.handoverReasonId == 8 &&
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6} style={{ textAlign: 'right' }}></Col>
                        <Col span={17} offset={1}>
                            <TextArea
                                placeholder="请输入其他原因备注"
                                value={saveParams.handoverReasonRemark}
                                autosize={{ minRows: 3, maxRows: 6 }}
                                onChange={e => this.handleChange(e.target.value, 'handoverReasonRemark')}
                            />
                        </Col>
                    </Row>
                }
                <Row >
                    <Col span={6} style={{ textAlign: 'right' }}>预计上岗时间：</Col>
                    <Col span={17} offset={1}>
                        <DatePicker
                            format={dateFormat}
                            style={{ width: 200 }}
                            value={saveParams.estimateCompletedTime ? moment(saveParams.estimateCompletedTime) : null}
                            onChange={(date, dateString) => this.handleChange(dateString, 'estimateCompletedTime')}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col span={6} style={{ textAlign: 'right' }}>预计完成交接时间：</Col>
                    <Col span={17} offset={1}>
                        <DatePicker
                            format={dateFormat}
                            style={{ width: 200 }}
                            value={saveParams.proCompTime ? moment(saveParams.proCompTime) : null}
                            onChange={(date, dateString) => this.handleChange(dateString, 'proCompTime')}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col span={6} style={{ textAlign: 'right' }}>预计交接的FTE：</Col>
                    <Col span={17} offset={1}>{this.showFteTable && this.getFteTable()}</Col>
                </Row>
            </Modal>
        );
    }
}

export default Update;



// WEBPACK FOOTER //
// ./src/components/user/transfer/CRCUpdate.js